import '../scss/App.scoped.scss';
import { useState, useEffect } from "react";

function ScHeader() {
  const [headerTxt, setHeaderTxt] = useState("Contact Sharecare to learn more.");
  const [pTxt, setPText] = useState("");
  //const [pTxt, setPText] = useState("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.");
  
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if(event.data.pform && event.data.pform === "pardot") {
        setHeaderTxt(event.data.heading ? event.data.heading : "");
        setPText(event.data.txt ? event.data.txt : "");
      }
      //console.log(event.data);
    }, false);
    window.parent.postMessage("ready","*");
  },[]);

  return (
  <div className="para">
    <div className="inner">
      <h2>{headerTxt}</h2>
      <p>{pTxt}</p>
    </div>
  </div>
  );
}

export default ScHeader;